import React, { useState } from 'react';
import '../client/ClientPortal.css';

const TransporterLoginPage = ({ onLoginSuccess }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const res = await fetch('/api/login/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password }),
            });
            const data = await res.json();
            if (!res.ok) {
                const msg = data.detail || '';
                if (msg.toLowerCase().includes('validity has expired')) {
                    setError('Your credentials validity period has expired. Please contact K & K Company Ltd.');
                } else {
                    setError(msg || 'Invalid username or password.');
                }
                return;
            }

            const userType = data.user_type;
            if (userType && userType !== 'TRANSPORTER') {
                setError('This portal is for transporters only. Please use the correct portal.');
                return;
            }

            onLoginSuccess(data);
        } catch {
            setError('Connection error. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="cp-login-root" style={{ background: 'linear-gradient(135deg, #1a472a 0%, #2e7d32 100%)' }}>
            <div className="cp-login-box">
                <div className="cp-login-logo">
                    <div className="logo-icon">
                        <i className="fa-solid fa-truck"></i>
                    </div>
                    <h1>K&amp;K Transporter Portal</h1>
                    <p>Sign in to view your EIR and invoices</p>
                </div>

                {error && <div className="cp-login-error">{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Username</label>
                        <input
                            type="text"
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                            required
                            autoFocus
                            autoComplete="username"
                        />
                    </div>
                    <div className="form-group">
                        <label>Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            required
                            autoComplete="current-password"
                        />
                    </div>
                    <button type="submit" className="cp-login-submit" disabled={loading}>
                        {loading ? 'Signing in...' : 'Sign In'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default TransporterLoginPage;
